import { useModalOpener } from "../../hooks/useModalOpener";
import NycbsExternalTable from "./components/nycbsExternalTable";

interface NycbsExternalProps {
  /** BigQuery org id — Non-STAT (`NYCBS_PHARMA`) or STAT (`NYCBS_STATS`). */
  orgId: string;
}

/**
 * NYCBS External PA Requests page. Renders the shared orders table scoped to the
 * given organization (Non-STAT or STAT tab).
 *
 * @param orgId - BigQuery organization id passed to the table API
 */
const NycbsExternal = ({ orgId }: NycbsExternalProps) => {
  useModalOpener();

  return (
    <div className="nycbs_external__layout h-full w-full bg-primaryGray-16 p-2">
      <div className="nycbs_external__inner-container flex h-full flex-col gap-2 overflow-hidden rounded bg-white p-4">
        <div className="nycbs_external__heading text-h11 font-bold">
          PA Requests
        </div>
        <div className="nycbs_external__table-container flex-1 overflow-auto">
          <NycbsExternalTable key={orgId} orgId={orgId} />
        </div>
      </div>
    </div>
  );
};

export default NycbsExternal;
